// src/components/Profile/ProfileChallenges.jsx

import React from 'react';
import { FaCheck, FaCircle } from 'react-icons/fa';

const ProfileChallenges = ({ formData, translations }) => {
  const t = translations.challenges;

  // Check if personal info section is complete
  const isPersonalInfoComplete = () => {
    return formData.first_name?.trim() && 
           formData.last_name?.trim() && 
           formData.email?.trim() && 
           formData.phone_number?.trim();
  };

  // Check if address info section is complete
  const isAddressInfoComplete = () => {
    return formData.street?.trim() && 
           formData.house_number?.trim() && 
           formData.city?.trim() && 
           formData.postal_code?.trim() && 
           formData.country?.trim();
  };

  // Check if business info section is complete
  const isBusinessInfoComplete = () => {
    return formData.restaurant_name?.trim() && 
           formData.vat_number?.trim() && 
           formData.tripadvisor_review_link?.trim() && 
           formData.google_review_link?.trim();
  };

  const challenges = [
    {
      id: 'personal',
      text: t.personalInfo,
      completed: isPersonalInfoComplete()
    },
    {
      id: 'address', 
      text: t.addressInfo,
      completed: isAddressInfoComplete()
    },
    {
      id: 'business',
      text: t.businessInfo,
      completed: isBusinessInfoComplete()
    }
  ];

  return (
    <div className="profile-challenges">
      <h3 className="challenges-title">{t.title}</h3>
      <ul className="challenges-list">
        {challenges.map((challenge) => (
          <li key={challenge.id} className={`challenge-item ${challenge.completed ? 'completed' : ''}`}>
            <span className="challenge-icon">
              {challenge.completed ? <FaCheck /> : <FaCircle />}
            </span>
            <span className="challenge-text">{challenge.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProfileChallenges;